import { useCallback } from 'react';
import { Switcher, Text, VStack } from '@direct-frontend/components';
// eslint-disable-next-line @direct-frontend/modules/slice-boundaries, @direct-frontend/modules/entry-point -- Нужно поправить
import { usePickupAddressContext } from '@/features/PickupAddressPicker/PickupAddressContext';
import { getRequestContext } from '@/shared/lib/requestContext';
import styles from './SelfPickupFilters.module.css';

export const SelfPickupFilters = () => {
    const { selfPickupFilters, changeSelfPickupFilters } = usePickupAddressContext();
    const {
        delivery: { multiWarehousesEnabled },
    } = getRequestContext();

    const onChangeTakeAllItems = useCallback(
        () => changeSelfPickupFilters('canTakeAllItems', !selfPickupFilters.canTakeAllItems),
        [changeSelfPickupFilters, selfPickupFilters.canTakeAllItems]
    );

    if (!multiWarehousesEnabled) {
        return null;
    }

    return (
        <VStack>
            <div className={styles.wrapper} onClick={onChangeTakeAllItems}>
                <Switcher isSelected={selfPickupFilters.canTakeAllItems} onChange={onChangeTakeAllItems} />

                <Text size="mc">С возможностью забрать все товары</Text>
            </div>
        </VStack>
    );
};
